export default __webpack_public_path__ + "static/media/stroller_supermarket.87ca60fe.svg";